<template>
  <div id="app" class="container">
    <div class="row">
      <contract-form class="no-print col-12 col-md-4" />
      <div class="col-12 col-md-8">
        <div class="row">
          <contract class="col-12" />
          <button-bar class="no-print col-12" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContractForm from './components/form/Form';
import Contract from './components/contract/Contract';
import ButtonBar from '@/shared/components/ButtonBar';

import danishForm from './translations/form/da_form.json';
import englishForm from './translations/form/en_form.json';
import danishContract from './translations/contract/da_contract.json';
// import englishContract from './translations/contract/en_contract.json';
// import frenchContract from './translations/contract/fr_contract.json';
// import germanContract from './translations/contract/de_contract.json';

export default {
  name: 'App',
  components: {
    ContractForm,
    Contract,
    ButtonBar,
  },
  computed: {
    formLocale() {
      return this.$store.state.contract.locale.formLocale;
    },
    contractLocale() {
      return this.$store.state.contract.locale.contractLocale;
    },
  },
  watch: {
    formLocale: {
      handler: function() {
        this.mergeTranslations();
      },
    },
    contractLocale: {
      handler: function() {
        this.mergeTranslations();
      },
    },
  },
  methods: {
    mergeTranslations() {
      let form;
      let contract;

      this.formLocale === 'da-DK' ? (form = danishForm) : (form = englishForm);

      contract = danishContract;

      // if (this.contractLocale === 'da-DK') {
      //   contract = danishContract;
      // } else if (this.contractLocale === 'en-UK') {
      //   contract = englishContract;
      // } else if (this.contractLocale === 'fr-FR') {
      //   contract = frenchContract;
      // } else if (this.contractLocale === 'de-DE') {
      //   contract = germanContract;
      // }

      let result = {
        ...contract,
        ...form,
      };

      this.$i18n.add('mix', result);
      this.$i18n.set('mix');
    },
  },
};
</script>

<style>
#app {
  max-width: 1440px;
  background-color: #fff;
  color: #313841;
  font-size: 16px;
  font-family: 'GT America', system-ui;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* overflow-y: auto;
  overflow-x: hidden; */
  margin: 1rem auto;
}

@media print {
  .no-print {
    display: none !important;
  }
}
</style>
